// import React, { Component } from 'react';

// // The 'data' array is no longer hardcoded here.
// // It will be passed as a prop to the DateDisplay component.

// class DateDisplay extends Component {
//   state = {
//     currentDisplay: null,
//     DateFormate: '',
//   };

//   intervalId = null;

//   componentDidMount() {
//     this.findAndSetDisplayData();
//     // Re-evaluate daily to update which period is active
//     this.intervalId = setInterval(this.findAndSetDisplayData, 24 * 60 * 60 * 1000);
//   }

//   componentDidUpdate(prevProps, prevState) {
//     // Check if currentDisplay has changed to re-format the date
//     if (prevState.currentDisplay !== this.state.currentDisplay && this.state.currentDisplay) {
//       this.formatAndSetDate();
      
//     }
//     // IMPORTANT: If the 'data' prop itself can change after the initial mount,
//     // you would also need to re-run findAndSetDisplayData if prevProps.data !== this.props.data
//     // For this example, we assume data prop is stable after mount.
//     if (prevProps.data !== this.props.data) {
//         this.findAndSetDisplayData();
//     }
//   }

//   componentWillUnmount() {
//     if (this.intervalId) {
//       clearInterval(this.intervalId);
//     }
//   }

//   // Helper function to get month name
//   getMonthName = (monthIndex) => {
//     const monthNames = [
//       "January", "February", "March", "April", "May", "June",
//       "July", "August", "September", "October", "November", "December"
//     ];
//     return monthNames[monthIndex];
//   };

//   // Method to format the date string
//   formatAndSetDate = () => {
//     const { currentDisplay } = this.state;
//     if (!currentDisplay) return;

//     const dateObjectFrom = new Date(currentDisplay.duration_from);
//     const dateObjectTo = new Date(currentDisplay.duration_to);

//     const dayFrom = dateObjectFrom.getDate();
//     const monthWordFrom = this.getMonthName(dateObjectFrom.getMonth());
//     const dayTo = dateObjectTo.getDate();
//     const monthWordTo = this.getMonthName(dateObjectTo.getMonth());

//     let formattedDateTime = '';

//     if (monthWordFrom === monthWordTo) {
//       formattedDateTime = `${dayFrom} - ${dayTo} of ${monthWordTo}`;
//     } else {
//       formattedDateTime = `From ${monthWordFrom} ${dayFrom} - To ${monthWordTo} ${dayTo}`;
//     }

//     this.setState({ DateFormate: formattedDateTime });
//   };

//   findAndSetDisplayData = () => {
//     // Access the data array from props
//     const { data } = this.props;

//     // Handle case where data prop might not be provided or is empty
//     if (!data || data.length === 0) {
//       this.setState({ currentDisplay: null, DateFormate: '' });
//       return;
//     }

//     const now = new Date();
//     const currentYear = now.getFullYear();

//     let activeData = null;
//     let nextUpcomingData = null;

//     // First, check for active data based on actual year
//     for (const item of data) { // Use this.props.data here
//       const actualFrom = new Date(item.duration_from);
//       const actualTo = new Date(item.duration_to);
//       const actualNow = now;

//       if (actualNow >= actualFrom && actualNow <= actualTo) {
//         activeData = item;
//         break;
//       }
//     }

//     // If no active data found, then find the next upcoming considering actual year
//     if (!activeData) {
//       let minFutureDate = Infinity;
//       let futureItem = null;

//       for (const item of data) { // Use this.props.data here
//         const actualFrom = new Date(item.duration_from);
//         if (actualFrom > now && actualFrom.getTime() < minFutureDate) {
//           minFutureDate = actualFrom.getTime();
//           futureItem = item;
//         }
//       }
//       nextUpcomingData = futureItem;
//     }

//     // If no active data and no future data in the current year,
//     // loop back to the earliest period in the *next* year
//     if (!activeData && !nextUpcomingData) {
//       let earliestData = null;
//       if (data.length > 0) { // Use this.props.data here
//         earliestData = data.reduce((prev, curr) => { // Use this.props.data here
//           const prevFrom = new Date(prev.duration_from);
//           const currFrom = new Date(curr.duration_from);
//           if (prevFrom.getMonth() < currFrom.getMonth()) {
//             return prev;
//           } else if (prevFrom.getMonth() === currFrom.getMonth()) {
//             return prevFrom.getDate() < currFrom.getDate() ? prev : curr;
//           } else {
//             return curr;
//           }
//         });

//         const nextYearFrom = new Date(earliestData.duration_from);
//         nextYearFrom.setFullYear(currentYear + 1);
//         const nextYearTo = new Date(earliestData.duration_to);
//         nextYearTo.setFullYear(currentYear + 1);

//         nextUpcomingData = {
//           ...earliestData,
//           duration_from: nextYearFrom.toISOString().split('T')[0],
//           duration_to: nextYearTo.toISOString().split('T')[0],
//         };
//       }
//     }

//     this.setState({
//       currentDisplay: activeData || nextUpcomingData,
//     });
//   };

//   render() {
//     const { currentDisplay, DateFormate } = this.state;

//     // If data was not provided or empty, currentDisplay might be null
//     if (!currentDisplay) {
//         // Render a more specific message if DateFormate indicates no data
//         if (DateFormate === '') {
//             return <p>{DateFormate}</p>;
//         }
//         return <p>Loading data or no relevant periods found...</p>;
//     }

//     return (
//     //   <div style={{ fontFamily: 'Arial, sans-serif', padding: '20px', border: '1px solid #ccc', borderRadius: '8px' }}>
//     //     <h2>Current/Next Active Period:</h2>
//     //     <p>
//     //       {DateFormate ? (
//     //         // Display formatted date if available
//     //         <strong>{DateFormate}</strong>
//     //       ) : (
//     //         // Fallback to raw dates if for some reason DateFormate is empty
//     //         <>
//     //           <strong>From:</strong> {currentDisplay.duration_from} <br />
//     //           <strong>To:</strong> {currentDisplay.duration_to}
//     //         </>
//     //       )}
//     //     </p>
//     //     <p>
//     //       <strong>ID:</strong> {currentDisplay.id}
//     //     </p>
//     //     <p style={{ fontSize: '0.9em', color: '#666' }}>
//     //       <em>(This display updates based on the current date, showing the active period or the next upcoming one,
//     //       looping to the next year if all periods for the current year have passed.)</em>
//     //     </p>
//     //   </div>
//       <span>{DateFormate}</span>
//     );
//   }
// }

// export default DateDisplay;
import React, { Component } from 'react';

class DateDisplay extends Component {
  state = {
    currentDisplay: null,
    DateFormate: '',
  };

  intervalId = null;

  componentDidMount() {
    this.findAndSetDisplayData();
    // Re-evaluate daily to update which period is active
    this.intervalId = setInterval(this.findAndSetDisplayData, 24 * 60 * 60 * 1000);
  }

  componentDidUpdate(prevProps, prevState) {
    // Check if currentDisplay has changed to re-format the date
    if (prevState.currentDisplay !== this.state.currentDisplay && this.state.currentDisplay) {
      this.formatAndSetDate();
    }
    // IMPORTANT: If the 'data' prop itself can change after the initial mount,
    // you would also need to re-run findAndSetDisplayData if prevProps.data !== this.props.data
    // For this example, we assume data prop is stable after mount.
    if (prevProps.data !== this.props.data) {
      this.findAndSetDisplayData();
    }
  }

  componentWillUnmount() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  // Helper function to get abbreviated month name
  getAbbreviatedMonthName = (monthIndex) => {
    const monthNames = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    return monthNames[monthIndex];
  };

  // Helper function to get day with ordinal suffix
  getDayWithOrdinal = (day) => {
    if (day > 3 && day < 21) return `${day}th`; // Covers 11th-13th
    switch (day % 10) {
      case 1: return `${day}st`;
      case 2: return `${day}nd`;
      case 3: return `${day}rd`;
      default: return `${day}th`;
    }
  };

  // Method to format the date string
  formatAndSetDate = () => {
    const { currentDisplay } = this.state;
    if (!currentDisplay) return;

    const dateObjectFrom = new Date(currentDisplay.duration_from);
    const dateObjectTo = new Date(currentDisplay.duration_to);

    const dayFrom = this.getDayWithOrdinal(dateObjectFrom.getDate());
    const monthAbbrFrom = this.getAbbreviatedMonthName(dateObjectFrom.getMonth());
    const yearFrom = dateObjectFrom.getFullYear();

    const dayTo = this.getDayWithOrdinal(dateObjectTo.getDate());
    const monthAbbrTo = this.getAbbreviatedMonthName(dateObjectTo.getMonth());
    const yearTo = dateObjectTo.getFullYear();

    let formattedDateTime = '';

    if (monthAbbrFrom === monthAbbrTo && yearFrom === yearTo) {
      formattedDateTime = `${dayFrom} - ${dayTo} ${monthAbbrTo} | ${yearTo}`;
    } else if (yearFrom === yearTo) {
      formattedDateTime = `${dayFrom} ${monthAbbrFrom} - ${dayTo} ${monthAbbrTo} | ${yearTo}`;
    } else {
      formattedDateTime = `${dayFrom} ${monthAbbrFrom} ${yearFrom} - ${dayTo} ${monthAbbrTo} ${yearTo}`;
    }

    this.setState({ DateFormate: formattedDateTime });
  };

  findAndSetDisplayData = () => {
    // Access the data array from props
    const { data } = this.props;

    // Handle case where data prop might not be provided or is empty
    if (!data || data.length === 0) {
      this.setState({ currentDisplay: null, DateFormate: '' });
      return;
    }

    const now = new Date();
    const currentYear = now.getFullYear();

    let activeData = null;
    let nextUpcomingData = null;

    // First, check for active data based on actual year
    for (const item of data) {
      const actualFrom = new Date(item.duration_from);
      const actualTo = new Date(item.duration_to);
      const actualNow = now;

      if (actualNow >= actualFrom && actualNow <= actualTo) {
        activeData = item;
        break;
      }
    }

    // If no active data found, then find the next upcoming considering actual year
    if (!activeData) {
      let minFutureDate = Infinity;
      let futureItem = null;

      for (const item of data) {
        const actualFrom = new Date(item.duration_from);
        if (actualFrom > now && actualFrom.getTime() < minFutureDate) {
          minFutureDate = actualFrom.getTime();
          futureItem = item;
        }
      }
      nextUpcomingData = futureItem;
    }

    // If no active data and no future data in the current year,
    // loop back to the earliest period in the *next* year
    if (!activeData && !nextUpcomingData) {
      let earliestData = null;
      if (data.length > 0) {
        earliestData = data.reduce((prev, curr) => {
          const prevFrom = new Date(prev.duration_from);
          const currFrom = new Date(curr.duration_from);
          if (prevFrom.getMonth() < currFrom.getMonth()) {
            return prev;
          } else if (prevFrom.getMonth() === currFrom.getMonth()) {
            return prevFrom.getDate() < currFrom.getDate() ? prev : curr;
          } else {
            return curr;
          }
        });

        const nextYearFrom = new Date(earliestData.duration_from);
        nextYearFrom.setFullYear(currentYear + 1);
        const nextYearTo = new Date(earliestData.duration_to);
        nextYearTo.setFullYear(currentYear + 1);

        nextUpcomingData = {
          ...earliestData,
          duration_from: nextYearFrom.toISOString().split('T')[0],
          duration_to: nextYearTo.toISOString().split('T')[0],
        };
      }
    }

    this.setState({
      currentDisplay: activeData || nextUpcomingData,
    });
  };

  render() {
    const { currentDisplay, DateFormate } = this.state;

    // If data was not provided or empty, currentDisplay might be null
    if (!currentDisplay) {
      // Render a more specific message if DateFormate indicates no data
      if (DateFormate === '') {
        return <p>{DateFormate}</p>;
      }
      return <p>Loading data or no relevant periods found...</p>;
    }

    return (
      <span >{DateFormate}</span>
    );
  }
}

export default DateDisplay;